module.exports = __webpack_public_path__ + "static/img/icon_duodianwangyuan@2x.6621354d.png";